import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

import {clientRpRequestMeta} from "../../../client/client_rp_request_meta";
import {IRPStore} from "../../app/rp_reducer";
import {fetchMarketplaceArchitects} from "../actions/fetch_marketplace_architects";

interface IProps {
    regionId?: number;
    withRegionOnly: boolean;
}

export const useMarketplaceArchitects = (props: IProps) => {
    const marketplaceArchitects = useSelector((state: IRPStore) => state.marketplace.architectList);
    const dispatch = useDispatch();

    useEffect(() => {
        if (props.withRegionOnly && !props.regionId) {
            return;
        }

        const ctx = {
            meta: clientRpRequestMeta,
            prevResult: {
                region: props.withRegionOnly ? props.regionId : undefined
            }
        };

        dispatch(fetchMarketplaceArchitects(ctx));
    }, [props.withRegionOnly, props?.regionId]);

    return marketplaceArchitects;
};
import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

import {clientRpRequestMeta} from "../../../client/client_rp_request_meta";
import {IRPStore} from "../../app/rp_reducer";
import {fetchMarketplaceArchitects} from "../actions/fetch_marketplace_architects";

interface IProps {
    regionId?: number;
    withRegionOnly: boolean;
}

export const useMarketplaceArchitects = (props: IProps) => {
    const marketplaceArchitects = useSelector((state: IRPStore) => state.marketplace.architectList);
    const dispatch = useDispatch();

    useEffect(() => {
        if (props.withRegionOnly && !props.regionId) {
            return;
        }

        const ctx = {
            meta: clientRpRequestMeta,
            prevResult: {
                region: props.withRegionOnly ? props.regionId : undefined
            }
        };

        dispatch(fetchMarketplaceArchitects(ctx));
    }, [props.withRegionOnly, props?.regionId]);

    return marketplaceArchitects;
};
